'use strict';

wbApp.controller('BankCtrl', ['$scope', '$modal', '$q', '$timeout', '$translate', 'messageBoxSvc', 'accountingBookSvc', 'bankSvc', 'notificationSvc',
function ($scope, $modal, $q, $timeout, $translate, messageBoxSvc, accountingBookSvc, bankSvc, notificationSvc) {

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.fromDate = moment().startOf('month').toDate();
    $scope.toDate = moment().endOf('month').toDate();
    $scope.records = null;

    $scope.$on('refreshData', function (e, data) {
        if ($scope.accountingBookID) {
            refreshData($scope.accountingBookID, $scope.fromDate, $scope.toDate);
        }
    });

    $q.all([accountingBookSvc.getDefaultAsync()])
    .then(function (data) {
        if (data && data.length === 1) {
            $scope.accountingBookID = data[0].id;
            $scope.onAccountingBookChange($scope.accountingBookID, $scope.fromDate, $scope.toDate);
        }
    });

    var unimportantRecoveryDetailDlgPromise = $modal({
        templateUrl: 'finance/bank/unimportant-recovery-detail.html',
        show: false,
        scope: $scope.$new()
    });

    function restoreIrrelevantTransactions() {
        unimportantRecoveryDetailDlgPromise.$promise.then(function () {
            unimportantRecoveryDetailDlgPromise.$scope.fromDate = $scope.fromDate;
            unimportantRecoveryDetailDlgPromise.$scope.toDate = $scope.toDate;
            unimportantRecoveryDetailDlgPromise.$scope.accountingBookID = $scope.accountingBookID;
            unimportantRecoveryDetailDlgPromise.$scope.onSave = function () {
                refreshData($scope.accountingBookID, $scope.fromDate, $scope.toDate);
            }

            unimportantRecoveryDetailDlgPromise.show();
        });
    }

    var addPaymentPromise = $modal({
        templateUrl: 'finance/payments/payments-detail.html',
        show: false,
        scope: $scope.$new()
    });

    function addPayment(data) {
        addPaymentPromise.$scope.isAddBankPayment = true;
        addPaymentPromise.$scope.bankTransactionDetail = {
            invoiceNo: data.invoiceNo,
            externalAccountNo: data.externalAccountNo,
            text: data.text,
            transactionID: data.transactionID,
            accountingBookID: $scope.accountingBookID
        };
        addPaymentPromise.$scope.paymentDetail = {
            paymentID: 0,
            paymentTypeID: 1,
            amount: data.value,
            selectedDate: data.date,
        };

        addPaymentPromise.$promise.then(function () {
            addPaymentPromise.$scope.detailError = null;
            addPaymentPromise.$scope.onPaymentSuccessSave = function () {
                refreshData($scope.accountingBookID, $scope.fromDate, $scope.toDate);
            }

            addPaymentPromise.show();
        });
    }

    $scope.gridOptions = {
        sortInfo: { fields: ['date'], directions: ['dsc'] },
        columnDefs: [{ field: 'date', displayName: "TXT_LBL_DATE", cellFilter: 'date:shortDate', width: '75px' },
                     { field: 'transactionNumber', displayName: "TXT_LBL_TRANSACTION_NUMBER", align: 'right', width: '100px', smHide: true },
                     { field: 'invoiceNo', displayName: "TXT_LBL_VARIABLE_SYMBOL", width: '120px', align: 'right' },
                     { field: 'externalAccountNo', displayName: "TXT_LBL_EXTERNAL_ACCOUNT", width: '190px', align: 'right', smHide: true, mdHide: true },
                     { field: 'text', displayName: "TXT_LBL_TEXT", sort: 'locale' },
                     { field: 'paymentID', displayName: "TXT_LBL_PAYMENT", cellFilter: 'checkmark', width: '60px', smHide: true },
                     { field: 'value', displayName: "TXT_LBL_VALUE", cellFilter: 'wbCurrencyFlt', width: '100px', align: 'right' }
        ],
        disabledField: 'paymentID',
        disabledAreSelectable: true,
        customCmds: [{
                text: 'TXT_MENU_CREATE_PAYMENT',
                hide: function (row) { return !!row.paymentID; },
                command: function (row) {
                    addPayment(row);
                }
            }, {
                text: 'TXT_MENU_MARK_AS_IRRELEVANT',
                hide: function (row) { return !!row.paymentID; },
                command: function (row) {                    
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_TITLE_CONFIRMATION',
                        message: 'TXT_CONFIRM_MARK_AS_IRRELEVANT_MESSAGE',
                        buttons: [{
                            text: 'TXT_BTN_CANCEL'
                        }, {
                            text: 'TXT_BTN_NO',
                        }, {
                            text: 'TXT_BTN_YES',
                            callback: function () {
                                bankSvc.markAsUnimportant($scope.accountingBookID, row.transactionID)
                                .then(function () {
                                    refreshData($scope.accountingBookID, $scope.fromDate, $scope.toDate);
                                },
                                function (errorResult) {
                                    notificationSvc.notifyError(
                                        $translate.instant('TXT_ALERT_TITLE_DATA_SAVE_ERROR'),
                                        notificationSvc.translateError(errorResult));
                                });
                            }
                        }]
                    });
                }
            }, {
                text: 'TXT_MENU_REMOVE_PAIRING',
                hide: function (row) { return !row.paymentID; },
                command: function (row) {
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_TITLE_CONFIRMATION',
                        message: 'TXT_CONFIRM_REMOVE_PAIRING_MESSAGE',
                        buttons: [{
                            text: 'TXT_BTN_CANCEL'
                        }, {
                            text: 'TXT_BTN_NO',
                        }, {
                            text: 'TXT_BTN_YES',
                            callback: function () {
                                bankSvc.removePairing($scope.accountingBookID, row.transactionID, false)
                                .then(function () {
                                    refreshData($scope.accountingBookID, $scope.fromDate, $scope.toDate);
                                },
                                function (errorResult) {
                                    notificationSvc.notifyError(
                                        $translate.instant('TXT_ALERT_TITLE_DATA_SAVE_ERROR'),
                                        notificationSvc.translateError(errorResult));
                                });
                            }
                        }]
                    });
                }
            }, {
                text: 'TXT_MENU_REMOVE_PAIRING_AND_DELETE_PAYMENT',
                hide: function (row) { return !row.paymentID; },
                command: function (row) {
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_TITLE_CONFIRMATION',
                        message: 'TXT_CONFIRM_REMOVE_PAIRING_WITH_DELETE_MESSAGE',
                        buttons: [{
                            text: 'TXT_BTN_CANCEL'
                        }, {
                            text: 'TXT_BTN_NO',
                        }, {
                            text: 'TXT_BTN_YES',
                            callback: function () {
                                bankSvc.removePairing($scope.accountingBookID, row.transactionID, true)
                                .then(function () {
                                    refreshData($scope.accountingBookID, $scope.fromDate, $scope.toDate);
                                },
                                function (errorResult) {
                                    notificationSvc.notifyError(
                                        $translate.instant('TXT_ALERT_TITLE_DATA_SAVE_ERROR'),
                                        notificationSvc.translateError(errorResult));
                                });
                            }
                        }]
                    });
                }
            }, {
                text: 'TXT_MENU_RESTORE_IRRELEVANT_TRANSACTIONS',
                command: function (row) {
                    restoreIrrelevantTransactions(row);
                }
            }, {
                text: 'TXT_MENU_REQUEST_AUTOMATIC_PAIRING',
                command: function (row) {
                    bankSvc.requestPairing($scope.accountingBookID)
                    .then(function () {
                        $timeout(function () {
                            messageBoxSvc.showMessageDlg({
                                title: 'TXT_TITLE_INFORMATION',
                                message: 'TXT_PAIRING_IN_PROGRESS',
                                buttons: [{
                                    text: 'TXT_BTN_OK'
                                }]
                            });
                        });
                    });
                }
            }]
    };


    function setSelectedRecord(selectedRecord) {
        if ($scope.selectedRecord !== selectedRecord) {
            $scope.selectedRecord = selectedRecord;
            $scope.$broadcast('selectedAccountingBookTransactionChanged', selectedRecord);
        }
    }

    function refreshData(accountingBookID, fromDate, toDate) {
        var records = bankSvc.getAllByAccountingBookID(accountingBookID, fromDate, toDate);

        if ($scope.records && $scope.records.length) {
            records.$promise.then(function (data) {
                $scope.records.length = 0;
                $scope.records.push.apply($scope.records, data);

                if ($scope.selectedRecord) {
                    setSelectedRecord(
                        _.find($scope.records, { transactionID: $scope.selectedRecord.transactionID }));
                    if ($scope.selectedRecord) {
                        $scope.selectedRecord.isSelected = true;
                    }
                }
            });
        } else {
            $scope.records = records;
            setSelectedRecord(null);
        }
    }

    $scope.onAccountingBookChange = function (accountingBookID) {
        if (accountingBookID) {
            refreshData(accountingBookID, $scope.fromDate, $scope.toDate);
        }
    }

    $scope.onFromDateChange = function (fromDate) {
        if (fromDate) {
            refreshData($scope.accountingBookID, fromDate, $scope.toDate);
        }
    }

    $scope.onToDateChange = function (toDate) {
        if (toDate) {
            refreshData($scope.accountingBookID, $scope.fromDate, toDate);
        }
    }

    $scope.onRowSelected = function (data) {
        setSelectedRecord(data);
    }

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "finance/bank/bank-tabs/paired-invoice.html"
    }];

    $scope.tabs.activeTab = 0;

}]);
